import { h } from "vue";

import {
    // icons
    IconBox,
    IconChartArea,
    IconClipboardCheck,
    IconCoins,
    IconFileLines,
    IconGear,
    IconHelmetSafety,
    IconUsers,
    IconCartShopping,
    IconWrench,
    IconScrewdriverWrench,
    IconPlug,
    IconClockHour4,
    IconMoneyBill,

    // route names
    SETTINGS_ROUTE_NAMES,
    CLIENT_ROUTE_NAMES,
    EMPLOYEE_ROUTE_NAMES,
    EXPENSE_ROUTE_NAMES,
    REPAIR_ROUTE_NAMES,
    REPORTS_ROUTE_NAMES,
    STORE_ROUTE_NAMES,
    SHIFT_ROUTE_NAMES,
    GENERAL_ROUTE_NAMES,
    SALARY_ROUTE_NAMES,
} from "@/shared";

import SidebarTooltipNoAccess from "../ui/SidebarTooltipNoAccess.vue";

// Страницы настроек без собственного пункта меню — подсвечивают «Конфигурацию».
// Редактор форм и интеграции перечислены отдельно: у них свои пункты.
const SETTINGS_INDEX_ROUTES = {
    INDEX: SETTINGS_ROUTE_NAMES.INDEX,
    QUICK_START: SETTINGS_ROUTE_NAMES.QUICK_START,
    CATEGORY_EDITOR: SETTINGS_ROUTE_NAMES.CATEGORY_EDITOR,
    CONTRACTS_LIST: SETTINGS_ROUTE_NAMES.CONTRACTS_LIST,
    CONTRACTS_ADD: SETTINGS_ROUTE_NAMES.CONTRACTS_ADD,
    CONTRACTS_EDIT: SETTINGS_ROUTE_NAMES.CONTRACTS_EDIT,
    IMPORT: SETTINGS_ROUTE_NAMES.IMPORT,
};

// Меню сгруппировано по задачам рабочего дня: сверху ежедневная работа, ниже
// склад, деньги, команда и настройки. Ключ группы — не константа доступа: свою
// константу группа не имеет, права считаются по вложенным пунктам.
// Заголовки групп сервер не переводит, поэтому у них label, а не title —
// так же, как у подпунктов «Конфигурации».
export default {
    MENU_LK_DASHBOARD: {
        icon: IconChartArea,
        title: "menu.analytics_section",

        to: { name: GENERAL_ROUTE_NAMES.DASHBOARD },
        activeRoutes: { DASHBOARD: GENERAL_ROUTE_NAMES.DASHBOARD },
    },
    GROUP_WORK: {
        label: "Работа",
        // Группа приёмщика: открыта с первого входа, к ней возвращаются весь день
        defaultOpened: true,

        activeRoutes: [
            REPAIR_ROUTE_NAMES.ORDER,
            CLIENT_ROUTE_NAMES,
            REPAIR_ROUTE_NAMES.SERVICE,
        ],
        children: {
            MENU_REPAIR: {
                icon: IconWrench,
                title: "menu.orders_section",
                shouldDisplayWithoutAccess: true,
                tooltipContent: h(SidebarTooltipNoAccess, {
                    tooltipText: "Мастерская недоступна на вашем тарифе",
                }),
                to: { name: REPAIR_ROUTE_NAMES.ORDER.LIST },
                activeRoutes: REPAIR_ROUTE_NAMES.ORDER,
            },
            MENU_H_CLIENT: {
                icon: IconUsers,
                title: "menu.clients",

                to: { name: CLIENT_ROUTE_NAMES.LIST },
                activeRoutes: CLIENT_ROUTE_NAMES,
            },
            MENU_REPAIR_SERVICE: {
                icon: IconScrewdriverWrench,
                title: "words.services",

                to: { name: REPAIR_ROUTE_NAMES.SERVICE.LIST },
                activeRoutes: REPAIR_ROUTE_NAMES.SERVICE,
            },
        },
    },
    GROUP_STOCK: {
        label: "Склад",

        activeRoutes: [
            STORE_ROUTE_NAMES.PRODUCT,
            STORE_ROUTE_NAMES.WAREHOUSE,
            STORE_ROUTE_NAMES.REORDER,
            STORE_ROUTE_NAMES.STOCK,
        ],
        children: {
            MENU_STOCK_PRODUCT: {
                icon: IconBox,
                title: "words.stock",

                to: { name: STORE_ROUTE_NAMES.PRODUCT.MAIN },
                activeRoutes: STORE_ROUTE_NAMES.PRODUCT,
            },
            // Остатки, приходы и списания — отдельный раздел: «Склад» выше это
            // каталог запчастей, а движение по складам живёт здесь.
            MENU_STOCK_WAREHOUSE: {
                icon: IconBox,
                title: "words.warehouse_parts",
                accessConst: "MENU_STOCK_PRODUCT",

                to: { name: STORE_ROUTE_NAMES.WAREHOUSE.MAIN },
                activeRoutes: STORE_ROUTE_NAMES.WAREHOUSE,
            },
            MENU_STOCK_REORDER: {
                icon: IconCartShopping,
                title: "words.warehouse_reorder",
                accessConst: "MENU_STOCK_PRODUCT",

                to: { name: STORE_ROUTE_NAMES.REORDER.MAIN },
                activeRoutes: STORE_ROUTE_NAMES.REORDER,
            },
            MENU_STOCK: {
                icon: IconCartShopping,
                title: "words.stocks",
                shouldDisplayWithoutAccess: true,
                tooltipContent: h(SidebarTooltipNoAccess, {
                    tooltipText: "Магазин недоступен на вашем тарифе",
                }),
                to: { name: STORE_ROUTE_NAMES.STOCK.MAIN },
                activeRoutes: STORE_ROUTE_NAMES.STOCK,
            },
        },
    },
    GROUP_MONEY: {
        label: "Деньги",

        activeRoutes: [
            REPORTS_ROUTE_NAMES,
            EXPENSE_ROUTE_NAMES,
            SALARY_ROUTE_NAMES,
        ],
        children: {
            MENU_H_REPORTS: {
                icon: IconFileLines,
                title: "menu.reports",

                to: { name: REPORTS_ROUTE_NAMES.REPORTS },
                activeRoutes: REPORTS_ROUTE_NAMES,
            },
            MENU_EXPENSE: {
                icon: IconCoins,
                title: "menu.expenses",

                to: { name: EXPENSE_ROUTE_NAMES.LIST },
                activeRoutes: EXPENSE_ROUTE_NAMES,
            },
            // Раздел зарплат открывался только по прямой ссылке: пункта меню не было
            MENU_H_EMPLOYEE_WAGE: {
                icon: IconMoneyBill,
                title: "words.salary",

                to: { name: SALARY_ROUTE_NAMES.LIST },
                activeRoutes: SALARY_ROUTE_NAMES,
            },
        },
    },
    GROUP_TEAM: {
        label: "Команда",

        activeRoutes: [EMPLOYEE_ROUTE_NAMES, SHIFT_ROUTE_NAMES],
        children: {
            MENU_H_EMPLOYEE: {
                icon: IconHelmetSafety,
                title: "menu.employees",

                to: { name: EMPLOYEE_ROUTE_NAMES.LIST },
                activeRoutes: EMPLOYEE_ROUTE_NAMES,
            },
            // Своей константы меню сервер не отдаёт: раздел открываем тем, у кого
            // есть доступ к сотрудникам, данные смен ограничены на стороне API
            MENU_SHIFT: {
                icon: IconClockHour4,
                title: "words.shifts",
                accessConst: "MENU_H_EMPLOYEE",

                to: { name: SHIFT_ROUTE_NAMES.MAIN },
                activeRoutes: SHIFT_ROUTE_NAMES,
            },
        },
    },
    GROUP_SETTINGS: {
        label: "Настройки",

        activeRoutes: [SETTINGS_ROUTE_NAMES],
        children: {
            MENU_LK_SETTINGS: {
                icon: IconGear,
                title: "words.settings_section",

                to: { name: SETTINGS_ROUTE_NAMES.INDEX },
                activeRoutes: SETTINGS_INDEX_ROUTES,
            },
            // Редактор формы приёмки открывается из меню, а не плиткой внутри
            // настроек: своей константы доступа у него нет, ходит за «Конфигурацией»
            MENU_LK_SETTINGS_REPAIR_FORM: {
                icon: IconClipboardCheck,
                label: "Редактор форм",
                accessConst: "MENU_LK_SETTINGS",

                to: { name: SETTINGS_ROUTE_NAMES.REPAIR_FORM },
                activeRoutes: { REPAIR_FORM: SETTINGS_ROUTE_NAMES.REPAIR_FORM },
            },
            MENU_LK_INTEGRATIONS: {
                icon: IconPlug,
                title: "words.integrations_section",

                to: { name: SETTINGS_ROUTE_NAMES.INTEGRATIONS },
                activeRoutes: {
                    INTEGRATIONS: SETTINGS_ROUTE_NAMES.INTEGRATIONS,
                },
            },
        },
    },
};
